import { createTheme } from '@material-ui/core/styles'

export function createAppTheme(mode = 'light') {
  const dark = mode === 'dark'
  const palette = {
    type: mode,
    primary: dark
      ? { main: '#8ab4f8', dark: '#6699e2', light: '#203957', contrastText: '#101b2b' }
      : { main: '#245ca8', dark: '#193f75', light: '#eaf2fc' },
    secondary: { main: dark ? '#afbed1' : '#52657c' },
    background: { default: dark ? '#101722' : '#f3f6fa', paper: dark ? '#1a2534' : '#ffffff' },
    text: { primary: dark ? '#e4ebf5' : '#1d2e45', secondary: dark ? '#a8b8cc' : '#617187' },
    divider: dark ? '#334155' : '#e2e8f0',
  }
  const surfaces = {
    subtle: dark ? '#16202e' : '#f7f9fc',
    stripe: dark ? '#1d2a3b' : '#fafbfd',
    hover: dark ? '#26394f' : '#f0f5fc',
    selected: dark ? '#203957' : '#eaf2fc',
  }

  return createTheme({
    palette,
    surfaces,
    typography: {
      fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif',
      button: { textTransform: 'none', fontWeight: 600 },
      h5: { fontWeight: 600, letterSpacing: '-0.025em' },
      h6: { fontWeight: 600, letterSpacing: '-0.015em' },
    },
    shape: { borderRadius: 10 },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          ':root': {
            colorScheme: mode,
            '--background': palette.background.default,
            '--paper': palette.background.paper,
            '--text-primary': palette.text.primary,
            '--text-secondary': palette.text.secondary,
            '--primary': palette.primary.main,
            '--divider': palette.divider,
            '--surface-subtle': surfaces.subtle,
            '--surface-selected': surfaces.selected,
            '--graph-background': dark ? '#263548' : '#ebebeb',
            '--graph-grid': dark ? '#41536b' : '#ffffff',
            '--check-nops': dark ? '#efaaaa' : '#8d3d3d',
            '--check-rq': dark ? '#e3c66c' : '#80651a',
          },
          a: { color: palette.primary.main },
          '::selection': { background: surfaces.selected, color: palette.text.primary },
        },
      },
      MuiPaper: {
        elevation1: { boxShadow: dark ? '0 2px 12px rgba(0, 0, 0, 0.2)' : '0 2px 12px rgba(29, 46, 69, 0.06)' },
        rounded: { border: `1px solid ${palette.divider}` },
      },
      MuiAppBar: {
        colorPrimary: { backgroundColor: palette.background.paper, color: palette.text.primary },
        colorDefault: { backgroundColor: palette.background.paper, color: palette.text.primary },
      },
      MuiButton: {
        root: { borderRadius: 7 },
        contained: { boxShadow: 'none', '&:hover': { boxShadow: 'none' } },
        outlined: { borderColor: dark ? palette.divider : '#cbd5e1' },
      },
      MuiTableCell: {
        root: { borderBottomColor: dark ? palette.divider : '#edf1f6' },
        head: { backgroundColor: surfaces.subtle, color: dark ? palette.text.secondary : '#4b5e76', fontWeight: 600 },
        body: { color: dark ? palette.text.primary : '#26384e' },
      },
      MuiTableSortLabel: { root: { '&$active': { color: palette.primary.main } } },
      MuiInput: {
        underline: {
          '&:before': { borderBottomColor: dark ? palette.divider : '#cbd5e1' },
          '&:hover:not($disabled):before': { borderBottomColor: palette.text.secondary },
        },
      },
      MuiInputLabel: { root: { color: palette.text.secondary } },
      MuiDialog: { paper: { borderRadius: 12 } },
      MuiDialogTitle: { root: { borderBottom: `1px solid ${palette.divider}` } },
      MuiTooltip: { tooltip: { backgroundColor: '#1d2e45', color: '#ffffff', fontSize: 12 } },
    },
  })
}

export default createAppTheme()
